
import React, { useEffect } from "react";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { isBrowser } from "@/utils/runtime";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const PrivacyPolicy = () => {
  // Set page title and meta tags for SEO
  useEffect(() => {
    if (!isBrowser) return;
    globalThis.document.title = "Política de Privacidade | Toc Toc IA";

    // Add meta description dynamically
    const metaDescription = globalThis.document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute("content",
        "Conheça nossa política de privacidade. Saiba como o Toc Toc IA coleta, usa e protege seus dados pessoais ao utilizar nossos serviços de edição de fotos para imóveis.");
    }

    // Set canonical URL
    let canonicalLink = globalThis.document.querySelector('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = globalThis.document.createElement('link');
      canonicalLink.setAttribute('rel', 'canonical');
      globalThis.document.head.appendChild(canonicalLink);
    }
    canonicalLink.setAttribute('href', 'https://toctoc.com.br/privacy-policy');
  }, []);

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      <main className="flex-1 container max-w-4xl mx-auto px-4 py-12">
        <div className="mb-8">
          <Button variant="ghost" asChild className="text-toctoc-blue mb-4">
            <Link to="/">
              <ArrowLeft className="mr-2 h-4 w-4" />
              Voltar para Home
            </Link>
          </Button>
          <h1 className="text-3xl font-bold mb-6 text-toctoc-black">Política de Privacidade</h1>
        </div>

        <div className="prose max-w-none">
          <p className="mb-4 text-toctoc-gray-dark">
            A Toc Flash valoriza sua privacidade. Esta Política de Privacidade descreve como coletamos, usamos e compartilhamos suas informações quando você usa nossos serviços.
          </p>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">1. Informações Coletadas</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Coletamos informações que você nos fornece diretamente, como seu nome, endereço de e-mail, informações de pagamento e quaisquer outras informações que você opte por fornecer.
          </p>
          <p className="mb-4 text-toctoc-gray-dark">
            Também coletamos automaticamente certos dados quando você usa nosso serviço, incluindo seu endereço IP, tipo de navegador, páginas visitadas e tempo gasto em nosso site.
          </p>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">2. Uso de Informações</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Utilizamos suas informações para:
          </p>
          <ul className="list-disc pl-8 mb-4 text-toctoc-gray-dark">
            <li>Fornecer, manter e melhorar nossos serviços</li>
            <li>Personalizar e aprimorar sua experiência</li>
            <li>Processar transações e enviar notificações relacionadas</li>
            <li>Responder a seus comentários, perguntas e solicitações</li>
            <li>Monitorar e analisar tendências, uso e atividades</li>
            <li>Detectar, prevenir e resolver problemas técnicos e de segurança</li>
          </ul>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">3. Compartilhamento de Informações</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Podemos compartilhar suas informações com:
          </p>
          <ul className="list-disc pl-8 mb-4 text-toctoc-gray-dark">
            <li>Fornecedores de serviços que trabalham em nosso nome</li>
            <li>Em resposta a requisições legais, processos ou ordens judiciais</li>
            <li>Para proteger os direitos e a segurança da Toc Flash e seus usuários</li>
            <li>Em conexão com uma fusão, venda de ativos da empresa ou aquisição</li>
          </ul>

          <h2 className="text-xl font-semibold mb-4 mt-8 text-toctoc-black">4. Seus Direitos</h2>
          <p className="mb-4 text-toctoc-gray-dark">
            Você tem determinados direitos em relação às suas informações pessoais, incluindo:
          </p>
          <ul className="list-disc pl-8 mb-4 text-toctoc-gray-dark">
            <li>Acessar, atualizar ou excluir suas informações</li>
            <li>Opor-se ao processamento de seus dados</li>
            <li>Solicitar restrições no processamento de seus dados</li>
            <li>Portabilidade de dados</li>
          </ul>

          <div className="border-t border-gray-200 pt-8 mt-8">
            <p className="text-toctoc-gray">Última atualização: 10 de maio de 2025</p>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
